import { Route, Routes } from "react-router-dom";
import List from "./List";
import New from "./New";
import Edit from "./Edit";
import "./style.css";

const PromptOverridesMspa = (): JSX.Element => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/new" element={<New />} />
      <Route path="/:id/edit" element={<Edit />} />
    </Routes>
  );
};

export default PromptOverridesMspa;
